// CCC-001 CC-S1 anti-regressão (Calvin 2026-06-11 "evitar regressão incluindo
// para novos módulos") — inline script de privacy.html extraído para arquivo externo.
// A CSP de produção (script-src sem unsafe-inline) bloquearia o bloco inline.

// Path relativo a /js/boot/ (o inline original era relativo à página).
import { hydrateContactSlots } from '../utils/admin/contactRegistry.js';
// T8.3 (fix): migra o switcher de 3 idiomas para o renderer de 16 locales —
// mesmo motor de terms-init.js (switcher dinâmico + fallback transparente
// pt-BR para locales sem tradução completa + RTL ar-SA).
import { initLegalPageI18n } from '../utils/i18n/legalPageRenderer.js';

hydrateContactSlots();

initLegalPageI18n({
    type: 'privacy',
    containerSelector: '.legal-container',
    switcherSelector: '.lang-switcher',
    titleSelector: '.legal-header h1',
    backLinkSelector: '.back-link',
});
